/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */


import {CompileIdentifierMetadata} from '../compile_metadata';
import {isPresent} from '../facade/lang';
export type TypeModifier = number;
export let TypeModifier: any = {};
TypeModifier.Const = 0;
TypeModifier[TypeModifier.Const] = "Const";

/**
 * @abstract
 */
export abstract class Type {
/**
 * @param {?=} modifiers
 */
constructor(public modifiers: TypeModifier[] = null) {
    if (!modifiers) {
      this.modifiers = [];
    }
  }
/**
 * @abstract
 * @param {?} visitor
 * @param {?} context
 * @return {?}
 */
visitType(visitor: TypeVisitor, context: any) {}
/**
 * @param {?} modifier
 * @return {?}
 */
hasModifier(modifier: TypeModifier): boolean { return this.modifiers.indexOf(modifier) !== -1; }
}

function Type_tsickle_Closure_declarations() {
 /** @type {?} */
Type.prototype.modifiers;
}

export type BuiltinTypeName = number;
export let BuiltinTypeName: any = {};
BuiltinTypeName.Dynamic = 0;
BuiltinTypeName.Bool = 1;
BuiltinTypeName.String = 2;
BuiltinTypeName.Int = 3;
BuiltinTypeName.Number = 4;
BuiltinTypeName.Function = 5;
BuiltinTypeName.Null = 6;
BuiltinTypeName[BuiltinTypeName.Dynamic] = "Dynamic";
BuiltinTypeName[BuiltinTypeName.Bool] = "Bool";
BuiltinTypeName[BuiltinTypeName.String] = "String";
BuiltinTypeName[BuiltinTypeName.Int] = "Int";
BuiltinTypeName[BuiltinTypeName.Number] = "Number";
BuiltinTypeName[BuiltinTypeName.Function] = "Function";
BuiltinTypeName[BuiltinTypeName.Null] = "Null";


export class BuiltinType extends Type {
/**
 * @param {?} name
 * @param {?=} modifiers
 */
constructor(public name: BuiltinTypeName, modifiers: TypeModifier[] = null) { super(modifiers); }
/**
 * @param {?} visitor
 * @param {?} context
 * @return {?}
 */
visitType(visitor: TypeVisitor, context: any): any {
    return visitor.visitBuiltintType(this, context);
  }
}

function BuiltinType_tsickle_Closure_declarations() {
 /** @type {?} */
BuiltinType.prototype.name;
}


export class ExpressionType extends Type {
/**
 * @param {?} value
 * @param {?=} typeParams
 * @param {?=} modifiers
 */
constructor(
public value: Expression,
public typeParams: Type[] = null,
      modifiers: TypeModifier[] = null) {
    super(modifiers);
  }
/**
 * @param {?} visitor
 * @param {?} context
 * @return {?}
 */
visitType(visitor: TypeVisitor, context: any): any {
    return visitor.visitExpressionType(this, context);
  }
}

function ExpressionType_tsickle_Closure_declarations() {
 /** @type {?} */
ExpressionType.prototype.value;
 /** @type {?} */
ExpressionType.prototype.typeParams;
}



export class ArrayType extends Type {
/**
 * @param {?} of
 * @param {?=} modifiers
 */
constructor(public of : Type, modifiers: TypeModifier[] = null) { super(modifiers); }
/**
 * @param {?} visitor
 * @param {?} context
 * @return {?}
 */
visitType(visitor: TypeVisitor, context: any): any {
    return visitor.visitArrayType(this, context);
  }
}

function ArrayType_tsickle_Closure_declarations() {
 /** @type {?} */
ArrayType.prototype.of;
}



export class MapType extends Type {
/**
 * @param {?} valueType
 * @param {?=} modifiers
 */
constructor(public valueType: Type, modifiers: TypeModifier[] = null) { super(modifiers); }
/**
 * @param {?} visitor
 * @param {?} context
 * @return {?}
 */
visitType(visitor: TypeVisitor, context: any): any { return visitor.visitMapType(this, context); }
}

function MapType_tsickle_Closure_declarations() {
 /** @type {?} */
MapType.prototype.valueType;
}


export var /** @type {?} */ DYNAMIC_TYPE = new BuiltinType(BuiltinTypeName.Dynamic);
export var /** @type {?} */ BOOL_TYPE = new BuiltinType(BuiltinTypeName.Bool);
export var /** @type {?} */ INT_TYPE = new BuiltinType(BuiltinTypeName.Int);
export var /** @type {?} */ NUMBER_TYPE = new BuiltinType(BuiltinTypeName.Number);
export var /** @type {?} */ STRING_TYPE = new BuiltinType(BuiltinTypeName.String);
export var /** @type {?} */ FUNCTION_TYPE = new BuiltinType(BuiltinTypeName.Function);
export var /** @type {?} */ NULL_TYPE = new BuiltinType(BuiltinTypeName.Null);

export interface TypeVisitor {
  visitBuiltintType(type: BuiltinType, context: any): any;
  visitExpressionType(type: ExpressionType, context: any): any;
  visitArrayType(type: ArrayType, context: any): any;
  visitMapType(type: MapType, context: any): any;
}
export type BinaryOperator = number;
export let BinaryOperator: any = {};
BinaryOperator.Equals = 0;
BinaryOperator.NotEquals = 1;
BinaryOperator.Identical = 2;
BinaryOperator.NotIdentical = 3;
BinaryOperator.Minus = 4;
BinaryOperator.Plus = 5;
BinaryOperator.Divide = 6;
BinaryOperator.Multiply = 7;
BinaryOperator.Modulo = 8;
BinaryOperator.And = 9;
BinaryOperator.Or = 10;
BinaryOperator.Lower = 11;
BinaryOperator.LowerEquals = 12;
BinaryOperator.Bigger = 13;
BinaryOperator.BiggerEquals = 14;
BinaryOperator[BinaryOperator.Equals] = "Equals";
BinaryOperator[BinaryOperator.NotEquals] = "NotEquals";
BinaryOperator[BinaryOperator.Identical] = "Identical";
BinaryOperator[BinaryOperator.NotIdentical] = "NotIdentical";
BinaryOperator[BinaryOperator.Minus] = "Minus";
BinaryOperator[BinaryOperator.Plus] = "Plus";
BinaryOperator[BinaryOperator.Divide] = "Divide";
BinaryOperator[BinaryOperator.Multiply] = "Multiply";
BinaryOperator[BinaryOperator.Modulo] = "Modulo";
BinaryOperator[BinaryOperator.And] = "And";
BinaryOperator[BinaryOperator.Or] = "Or";
BinaryOperator[BinaryOperator.Lower] = "Lower";
BinaryOperator[BinaryOperator.LowerEquals] = "LowerEquals";
BinaryOperator[BinaryOperator.Bigger] = "Bigger";
BinaryOperator[BinaryOperator.BiggerEquals] = "BiggerEquals";

/**
 * @abstract
 */
export abstract class Expression {
/**
 * @param {?} type
 */
constructor(public type: Type) {}
/**
 * @abstract
 * @param {?} visitor
 * @param {?} context
 * @return {?}
 */
visitExpression(visitor: ExpressionVisitor, context: any) {}
/**
 * @param {?} name
 * @return {?}
 */
prop(name: string): ReadPropExpr { return new ReadPropExpr(this, name); }
/**
 * @param {?} index
 * @param {?=} type
 * @return {?}
 */
key(index: Expression, type: Type = null): ReadKeyExpr {
    return new ReadKeyExpr(this, index, type);
  }
/**
 * @param {?} name
 * @param {?} params
 * @return {?}
 */
callMethod(name: string|BuiltinMethod, params: Expression[]): InvokeMethodExpr {
    return new InvokeMethodExpr(this, name, params);
  }
/**
 * @param {?} params
 * @return {?}
 */
callFn(params: Expression[]): InvokeFunctionExpr { return new InvokeFunctionExpr(this, params); }
/**
 * @param {?} params
 * @param {?=} type
 * @return {?}
 */
instantiate(params: Expression[], type: Type = null): InstantiateExpr {
    return new InstantiateExpr(this, params, type);
  }
/**
 * @param {?} trueCase
 * @param {?=} falseCase
 * @return {?}
 */
conditional(trueCase: Expression, falseCase: Expression = null): ConditionalExpr {
    return new ConditionalExpr(this, trueCase, falseCase);
  }
/**
 * @param {?} rhs
 * @return {?}
 */
equals(rhs: Expression): BinaryOperatorExpr {
    return new BinaryOperatorExpr(BinaryOperator.Equals, this, rhs);
  }
/**
 * @param {?} rhs
 * @return {?}
 */
notEquals(rhs: Expression): BinaryOperatorExpr {
    return new BinaryOperatorExpr(BinaryOperator.NotEquals, this, rhs);
  }
/**
 * @param {?} rhs
 * @return {?}
 */
identical(rhs: Expression): BinaryOperatorExpr {
    return new BinaryOperatorExpr(BinaryOperator.Identical, this, rhs);
  }
/**
 * @param {?} rhs
 * @return {?}
 */
notIdentical(rhs: Expression): BinaryOperatorExpr {
    return new BinaryOperatorExpr(BinaryOperator.NotIdentical, this, rhs);
  }
/**
 * @param {?} rhs
 * @return {?}
 */
minus(rhs: Expression): BinaryOperatorExpr {
    return new BinaryOperatorExpr(BinaryOperator.Minus, this, rhs);
  }
/**
 * @param {?} rhs
 * @return {?}
 */
plus(rhs: Expression): BinaryOperatorExpr {
    return new BinaryOperatorExpr(BinaryOperator.Plus, this, rhs);
  }
/**
 * @param {?} rhs
 * @return {?}
 */
divide(rhs: Expression): BinaryOperatorExpr {
    return new BinaryOperatorExpr(BinaryOperator.Divide, this, rhs);
  }
/**
 * @param {?} rhs
 * @return {?}
 */
multiply(rhs: Expression): BinaryOperatorExpr {
    return new BinaryOperatorExpr(BinaryOperator.Multiply, this, rhs);
  }
/**
 * @param {?} rhs
 * @return {?}
 */
modulo(rhs: Expression): BinaryOperatorExpr {
    return new BinaryOperatorExpr(BinaryOperator.Modulo, this, rhs);
  }
/**
 * @param {?} rhs
 * @return {?}
 */
and(rhs: Expression): BinaryOperatorExpr {
    return new BinaryOperatorExpr(BinaryOperator.And, this, rhs);
  }
/**
 * @param {?} rhs
 * @return {?}
 */
or(rhs: Expression): BinaryOperatorExpr {
    return new BinaryOperatorExpr(BinaryOperator.Or, this, rhs);
  }
/**
 * @param {?} rhs
 * @return {?}
 */
lower(rhs: Expression): BinaryOperatorExpr {
    return new BinaryOperatorExpr(BinaryOperator.Lower, this, rhs);
  }
/**
 * @param {?} rhs
 * @return {?}
 */
lowerEquals(rhs: Expression): BinaryOperatorExpr {
    return new BinaryOperatorExpr(BinaryOperator.LowerEquals, this, rhs);
  }
/**
 * @param {?} rhs
 * @return {?}
 */
bigger(rhs: Expression): BinaryOperatorExpr {
    return new BinaryOperatorExpr(BinaryOperator.Bigger, this, rhs);
  }
/**
 * @param {?} rhs
 * @return {?}
 */
biggerEquals(rhs: Expression): BinaryOperatorExpr {
    return new BinaryOperatorExpr(BinaryOperator.BiggerEquals, this, rhs);
  }
/**
 * @return {?}
 */
isBlank(): Expression {
    // Note: We use equals by purpose here to compare to null and undefined in JS.
    // We use the typed null to allow strictNullChecks to narrow types.
    return this.equals(TYPED_NULL_EXPR);
  }
/**
 * @param {?} type
 * @return {?}
 */
cast(type: Type): Expression { return new CastExpr(this, type); }
/**
 * @return {?}
 */
toStmt(): Statement { return new ExpressionStatement(this); }
}

function Expression_tsickle_Closure_declarations() {
 /** @type {?} */
Expression.prototype.type;
}

export type BuiltinVar = number;
export let BuiltinVar: any = {};
BuiltinVar.This = 0;
BuiltinVar.Super = 1;
BuiltinVar.CatchError = 2;
BuiltinVar.CatchStack = 3;
BuiltinVar[BuiltinVar.This] = "This";
BuiltinVar[BuiltinVar.Super] = "Super";
BuiltinVar[BuiltinVar.CatchError] = "CatchError";
BuiltinVar[BuiltinVar.CatchStack] = "CatchStack";


export class ReadVarExpr extends Expression {
public name: string;
public builtin: BuiltinVar;
/**
 * @param {?} name
 * @param {?=} type
 */
constructor(name: string|BuiltinVar, type: Type = null) {
    super(type);
    if (typeof name === 'string') {
      this.name = name;
      this.builtin = null;
    } else {
      this.name = null;
      this.builtin = <BuiltinVar>name;
    }
  }
/**
 * @param {?} visitor
 * @param {?} context
 * @return {?}
 */
visitExpression(visitor: ExpressionVisitor, context: any): any {
    return visitor.visitReadVarExpr(this, context);
  }
/**
 * @param {?} value
 * @return {?}
 */
set(value: Expression): WriteVarExpr { return new WriteVarExpr(this.name, value); }
}

function ReadVarExpr_tsickle_Closure_declarations() {
 /** @type {?} */
ReadVarExpr.prototype.name;
 /** @type {?} */
ReadVarExpr.prototype.builtin;
}



export class WriteVarExpr extends Expression {
public value: Expression;
/**
 * @param {?} name
 * @param {?} value
 * @param {?=} type
 */
constructor(public name: string, value: Expression, type: Type = null) {
    super(type || value.type);
    this.value = value;
  }
/**
 * @param {?} visitor
 * @param {?} context
 * @return {?}
 */
visitExpression(visitor: ExpressionVisitor, context: any): any {
    return visitor.visitWriteVarExpr(this, context);
  }
/**
 * @param {?=} type
 * @param {?=} modifiers
 * @return {?}
 */
toDeclStmt(type: Type = null, modifiers: StmtModifier[] = null): DeclareVarStmt {
    return new DeclareVarStmt(this.name, this.value, type, modifiers);
  }
}

function WriteVarExpr_tsickle_Closure_declarations() {
 /** @type {?} */
WriteVarExpr.prototype.value;
 /** @type {?} */
WriteVarExpr.prototype.name;
}



export class WriteKeyExpr extends Expression {
public value: Expression;
/**
 * @param {?} receiver
 * @param {?} index
 * @param {?} value
 * @param {?=} type
 */
constructor(
public receiver: Expression,
public index: Expression, value: Expression, type: Type = null) {
    super(type || value.type);
    this.value = value;
  }
/**
 * @param {?} visitor
 * @param {?} context
 * @return {?}
 */
visitExpression(visitor: ExpressionVisitor, context: any): any {
    return visitor.visitWriteKeyExpr(this, context);
  }
}

function WriteKeyExpr_tsickle_Closure_declarations() {
 /** @type {?} */
WriteKeyExpr.prototype.value;
 /** @type {?} */
WriteKeyExpr.prototype.receiver;
 /** @type {?} */
WriteKeyExpr.prototype.index;
}



export class WritePropExpr extends Expression {
public value: Expression;
/**
 * @param {?} receiver
 * @param {?} name
 * @param {?} value
 * @param {?=} type
 */
constructor(
public receiver: Expression,
public name: string, value: Expression, type: Type = null) {
    super(type || value.type);
    this.value = value;
  }
/**
 * @param {?} visitor
 * @param {?} context
 * @return {?}
 */
visitExpression(visitor: ExpressionVisitor, context: any): any {
    return visitor.visitWritePropExpr(this, context);
  }
}

function WritePropExpr_tsickle_Closure_declarations() {
 /** @type {?} */
WritePropExpr.prototype.value;
 /** @type {?} */
WritePropExpr.prototype.receiver;
 /** @type {?} */
WritePropExpr.prototype.name;
}

export type BuiltinMethod = number;
export let BuiltinMethod: any = {};
BuiltinMethod.ConcatArray = 0;
BuiltinMethod.SubscribeObservable = 1;
BuiltinMethod.Bind = 2;
BuiltinMethod[BuiltinMethod.ConcatArray] = "ConcatArray";
BuiltinMethod[BuiltinMethod.SubscribeObservable] = "SubscribeObservable";
BuiltinMethod[BuiltinMethod.Bind] = "Bind";


export class InvokeMethodExpr extends Expression {
public name: string;
public builtin: BuiltinMethod;
/**
 * @param {?} receiver
 * @param {?} method
 * @param {?} args
 * @param {?=} type
 */
constructor(
public receiver: Expression, method: string|BuiltinMethod,
public args: Expression[],
      type: Type = null) {
    super(type);
    if (typeof method === 'string') {
      this.name = method;
      this.builtin = null;
    } else {
      this.name = null;
      this.builtin = <BuiltinMethod>method;
    }
  }
/**
 * @param {?} visitor
 * @param {?} context
 * @return {?}
 */
visitExpression(visitor: ExpressionVisitor, context: any): any {
    return visitor.visitInvokeMethodExpr(this, context);
  }
}

function InvokeMethodExpr_tsickle_Closure_declarations() {
 /** @type {?} */
InvokeMethodExpr.prototype.name;
 /** @type {?} */
InvokeMethodExpr.prototype.builtin;
 /** @type {?} */
InvokeMethodExpr.prototype.receiver;
 /** @type {?} */
InvokeMethodExpr.prototype.args;
}



export class InvokeFunctionExpr extends Expression {
/**
 * @param {?} fn
 * @param {?} args
 * @param {?=} type
 */
constructor(public fn: Expression,
public args: Expression[], type: Type = null) { super(type); }
/**
 * @param {?} visitor
 * @param {?} context
 * @return {?}
 */
visitExpression(visitor: ExpressionVisitor, context: any): any {
    return visitor.visitInvokeFunctionExpr(this, context);
  }
}

function InvokeFunctionExpr_tsickle_Closure_declarations() {
 /** @type {?} */
InvokeFunctionExpr.prototype.fn;
 /** @type {?} */
InvokeFunctionExpr.prototype.args;
}



export class InstantiateExpr extends Expression {
/**
 * @param {?} classExpr
 * @param {?} args
 * @param {?=} type
 */
constructor(public classExpr: Expression,
public args: Expression[], type?: Type) { super(type); }
/**
 * @param {?} visitor
 * @param {?} context
 * @return {?}
 */
visitExpression(visitor: ExpressionVisitor, context: any): any {
    return visitor.visitInstantiateExpr(this, context);
  }
}

function InstantiateExpr_tsickle_Closure_declarations() {
 /** @type {?} */
InstantiateExpr.prototype.classExpr;
 /** @type {?} */
InstantiateExpr.prototype.args;
}



export class LiteralExpr extends Expression {
/**
 * @param {?} value
 * @param {?=} type
 */
constructor(public value: any, type: Type = null) { super(type); }
/**
 * @param {?} visitor
 * @param {?} context
 * @return {?}
 */
visitExpression(visitor: ExpressionVisitor, context: any): any {
    return visitor.visitLiteralExpr(this, context);
  }
}

function LiteralExpr_tsickle_Closure_declarations() {
 /** @type {?} */
LiteralExpr.prototype.value;
}



export class ExternalExpr extends Expression {
/**
 * @param {?} value
 * @param {?=} type
 * @param {?=} typeParams
 */
constructor(
public value: CompileIdentifierMetadata, type: Type = null,
public typeParams: Type[] = null) {
    super(type);
  }
/**
 * @param {?} visitor
 * @param {?} context
 * @return {?}
 */
visitExpression(visitor: ExpressionVisitor, context: any): any {
    return visitor.visitExternalExpr(this, context);
  }
}

function ExternalExpr_tsickle_Closure_declarations() {
 /** @type {?} */
ExternalExpr.prototype.value;
 /** @type {?} */
ExternalExpr.prototype.typeParams;
}



export class ConditionalExpr extends Expression {
public trueCase: Expression;
/**
 * @param {?} condition
 * @param {?} trueCase
 * @param {?=} falseCase
 * @param {?=} type
 */
constructor(
public condition: Expression, trueCase: Expression,
public falseCase: Expression = null,
      type: Type = null) {
    super(type || trueCase.type);
    this.trueCase = trueCase;
  }
/**
 * @param {?} visitor
 * @param {?} context
 * @return {?}
 */
visitExpression(visitor: ExpressionVisitor, context: any): any {
    return visitor.visitConditionalExpr(this, context);
  }
}

function ConditionalExpr_tsickle_Closure_declarations() {
 /** @type {?} */
ConditionalExpr.prototype.trueCase;
 /** @type {?} */
ConditionalExpr.prototype.condition;
 /** @type {?} */
ConditionalExpr.prototype.falseCase;
}



export class NotExpr extends Expression {
/**
 * @param {?} condition
 */
constructor(public condition: Expression) { super(BOOL_TYPE); }
/**
 * @param {?} visitor
 * @param {?} context
 * @return {?}
 */
visitExpression(visitor: ExpressionVisitor, context: any): any {
    return visitor.visitNotExpr(this, context);
  }
}

function NotExpr_tsickle_Closure_declarations() {
 /** @type {?} */
NotExpr.prototype.condition;
}


export class CastExpr extends Expression {
/**
 * @param {?} value
 * @param {?} type
 */
constructor(public value: Expression, type: Type) { super(type); }
/**
 * @param {?} visitor
 * @param {?} context
 * @return {?}
 */
visitExpression(visitor: ExpressionVisitor, context: any): any {
    return visitor.visitCastExpr(this, context);
  }
}

function CastExpr_tsickle_Closure_declarations() {
 /** @type {?} */
CastExpr.prototype.value;
}



export class FnParam {
/**
 * @param {?} name
 * @param {?=} type
 */
constructor(public name: string,
public type: Type = null) {}
}

function FnParam_tsickle_Closure_declarations() {
 /** @type {?} */
FnParam.prototype.name;
 /** @type {?} */
FnParam.prototype.type;
}



export class FunctionExpr extends Expression {
/**
 * @param {?} params
 * @param {?} statements
 * @param {?=} type
 */
constructor(public params: FnParam[],
public statements: Statement[], type: Type = null) {
    super(type);
  }
/**
 * @param {?} visitor
 * @param {?} context
 * @return {?}
 */
visitExpression(visitor: ExpressionVisitor, context: any): any {
    return visitor.visitFunctionExpr(this, context);
  }
/**
 * @param {?} name
 * @param {?=} modifiers
 * @return {?}
 */
toDeclStmt(name: string, modifiers: StmtModifier[] = null): DeclareFunctionStmt {
    return new DeclareFunctionStmt(name, this.params, this.statements, this.type, modifiers);
  }
}

function FunctionExpr_tsickle_Closure_declarations() {
 /** @type {?} */
FunctionExpr.prototype.params;
 /** @type {?} */
FunctionExpr.prototype.statements;
}



export class BinaryOperatorExpr extends Expression {
public lhs: Expression;
/**
 * @param {?} operator
 * @param {?} lhs
 * @param {?} rhs
 * @param {?=} type
 */
constructor(
public operator: BinaryOperator, lhs: Expression,
public rhs: Expression, type: Type = null) {
    super(type || lhs.type);
    this.lhs = lhs;
  }
/**
 * @param {?} visitor
 * @param {?} context
 * @return {?}
 */
visitExpression(visitor: ExpressionVisitor, context: any): any {
    return visitor.visitBinaryOperatorExpr(this, context);
  }
}

function BinaryOperatorExpr_tsickle_Closure_declarations() {
 /** @type {?} */
BinaryOperatorExpr.prototype.lhs;
 /** @type {?} */
BinaryOperatorExpr.prototype.operator;
 /** @type {?} */
BinaryOperatorExpr.prototype.rhs;
}



export class ReadPropExpr extends Expression {
/**
 * @param {?} receiver
 * @param {?} name
 * @param {?=} type
 */
constructor(public receiver: Expression,
public name: string, type: Type = null) { super(type); }
/**
 * @param {?} visitor
 * @param {?} context
 * @return {?}
 */
visitExpression(visitor: ExpressionVisitor, context: any): any {
    return visitor.visitReadPropExpr(this, context);
  }
/**
 * @param {?} value
 * @return {?}
 */
set(value: Expression): WritePropExpr {
    return new WritePropExpr(this.receiver, this.name, value);
  }
}

function ReadPropExpr_tsickle_Closure_declarations() {
 /** @type {?} */
ReadPropExpr.prototype.receiver;
 /** @type {?} */
ReadPropExpr.prototype.name;
}



export class ReadKeyExpr extends Expression {
/**
 * @param {?} receiver
 * @param {?} index
 * @param {?=} type
 */
constructor(public receiver: Expression,
public index: Expression, type: Type = null) {
    super(type);
  }
/**
 * @param {?} visitor
 * @param {?} context
 * @return {?}
 */
visitExpression(visitor: ExpressionVisitor, context: any): any {
    return visitor.visitReadKeyExpr(this, context);
  }
/**
 * @param {?} value
 * @return {?}
 */
set(value: Expression): WriteKeyExpr {
    return new WriteKeyExpr(this.receiver, this.index, value);
  }
}

function ReadKeyExpr_tsickle_Closure_declarations() {
 /** @type {?} */
ReadKeyExpr.prototype.receiver;
 /** @type {?} */
ReadKeyExpr.prototype.index;
}



export class LiteralArrayExpr extends Expression {
public entries: Expression[];
/**
 * @param {?} entries
 * @param {?=} type
 */
constructor(entries: Expression[], type: Type = null) {
    super(type);
    this.entries = entries;
  }
/**
 * @param {?} visitor
 * @param {?} context
 * @return {?}
 */
visitExpression(visitor: ExpressionVisitor, context: any): any {
    return visitor.visitLiteralArrayExpr(this, context);
  }
}

function LiteralArrayExpr_tsickle_Closure_declarations() {
 /** @type {?} */
LiteralArrayExpr.prototype.entries;
}


export class LiteralMapEntry {
/**
 * @param {?} key
 * @param {?} value
 * @param {?=} quoted
 */
constructor(public key: string,
public value: Expression,
public quoted: boolean = false) {}
}

function LiteralMapEntry_tsickle_Closure_declarations() {
 /** @type {?} */
LiteralMapEntry.prototype.key;
 /** @type {?} */
LiteralMapEntry.prototype.value;
 /** @type {?} */
LiteralMapEntry.prototype.quoted;
}


export class LiteralMapExpr extends Expression {
public valueType: Type = null;
/**
 * @param {?} entries
 * @param {?=} type
 */
constructor(public entries: LiteralMapEntry[], type: MapType = null) {
    super(type);
    if (isPresent(type)) {
      this.valueType = type.valueType;
    }
  }
/**
 * @param {?} visitor
 * @param {?} context
 * @return {?}
 */
visitExpression(visitor: ExpressionVisitor, context: any): any {
    return visitor.visitLiteralMapExpr(this, context);
  }
}

function LiteralMapExpr_tsickle_Closure_declarations() {
 /** @type {?} */
LiteralMapExpr.prototype.valueType;
 /** @type {?} */
LiteralMapExpr.prototype.entries;
}


export interface ExpressionVisitor {
  visitReadVarExpr(ast: ReadVarExpr, context: any): any;
  visitWriteVarExpr(expr: WriteVarExpr, context: any): any;
  visitWriteKeyExpr(expr: WriteKeyExpr, context: any): any;
  visitWritePropExpr(expr: WritePropExpr, context: any): any;
  visitInvokeMethodExpr(ast: InvokeMethodExpr, context: any): any;
  visitInvokeFunctionExpr(ast: InvokeFunctionExpr, context: any): any;
  visitInstantiateExpr(ast: InstantiateExpr, context: any): any;
  visitLiteralExpr(ast: LiteralExpr, context: any): any;
  visitExternalExpr(ast: ExternalExpr, context: any): any;
  visitConditionalExpr(ast: ConditionalExpr, context: any): any;
  visitNotExpr(ast: NotExpr, context: any): any;
  visitCastExpr(ast: CastExpr, context: any): any;
  visitFunctionExpr(ast: FunctionExpr, context: any): any;
  visitBinaryOperatorExpr(ast: BinaryOperatorExpr, context: any): any;
  visitReadPropExpr(ast: ReadPropExpr, context: any): any;
  visitReadKeyExpr(ast: ReadKeyExpr, context: any): any;
  visitLiteralArrayExpr(ast: LiteralArrayExpr, context: any): any;
  visitLiteralMapExpr(ast: LiteralMapExpr, context: any): any;
}

export var /** @type {?} */ THIS_EXPR = new ReadVarExpr(BuiltinVar.This);
export var /** @type {?} */ SUPER_EXPR = new ReadVarExpr(BuiltinVar.Super);
export var /** @type {?} */ CATCH_ERROR_VAR = new ReadVarExpr(BuiltinVar.CatchError);
export var /** @type {?} */ CATCH_STACK_VAR = new ReadVarExpr(BuiltinVar.CatchStack);
export var /** @type {?} */ NULL_EXPR = new LiteralExpr(null, null);
export var /** @type {?} */ TYPED_NULL_EXPR = new LiteralExpr(null, NULL_TYPE);
export type StmtModifier = number;
export let StmtModifier: any = {};
StmtModifier.Final = 0;
StmtModifier.Private = 1;
StmtModifier[StmtModifier.Final] = "Final";
StmtModifier[StmtModifier.Private] = "Private";

/**
 * @abstract
 */
export abstract class Statement {
/**
 * @param {?=} modifiers
 */
constructor(public modifiers: StmtModifier[] = null) {
    if (!modifiers) {
      this.modifiers = [];
    }
  }
/**
 * @abstract
 * @param {?} visitor
 * @param {?} context
 * @return {?}
 */
visitStatement(visitor: StatementVisitor, context: any) {}
/**
 * @param {?} modifier
 * @return {?}
 */
hasModifier(modifier: StmtModifier): boolean { return this.modifiers.indexOf(modifier) !== -1; }
}

function Statement_tsickle_Closure_declarations() {
 /** @type {?} */
Statement.prototype.modifiers;
}



export class DeclareVarStmt extends Statement {
public type: Type;
/**
 * @param {?} name
 * @param {?} value
 * @param {?=} type
 * @param {?=} modifiers
 */
constructor(
public name: string,
public value: Expression, type: Type = null,
      modifiers: StmtModifier[] = null) {
    super(modifiers);
    this.type = type || value.type;
  }
/**
 * @param {?} visitor
 * @param {?} context
 * @return {?}
 */
visitStatement(visitor: StatementVisitor, context: any): any {
    return visitor.visitDeclareVarStmt(this, context);
  }
}

function DeclareVarStmt_tsickle_Closure_declarations() {
 /** @type {?} */
DeclareVarStmt.prototype.type;
 /** @type {?} */
DeclareVarStmt.prototype.name;
 /** @type {?} */
DeclareVarStmt.prototype.value;
}


export class DeclareFunctionStmt extends Statement {
/**
 * @param {?} name
 * @param {?} params
 * @param {?} statements
 * @param {?=} type
 * @param {?=} modifiers
 */
constructor(
public name: string,
public params: FnParam[],
public statements: Statement[],
public type: Type = null, modifiers: StmtModifier[] = null) {
    super(modifiers);
  }
/**
 * @param {?} visitor
 * @param {?} context
 * @return {?}
 */
visitStatement(visitor: StatementVisitor, context: any): any {
    return visitor.visitDeclareFunctionStmt(this, context);
  }
}

function DeclareFunctionStmt_tsickle_Closure_declarations() {
 /** @type {?} */
DeclareFunctionStmt.prototype.name;
 /** @type {?} */
DeclareFunctionStmt.prototype.params;
 /** @type {?} */
DeclareFunctionStmt.prototype.statements;
 /** @type {?} */
DeclareFunctionStmt.prototype.type;
}


export class ExpressionStatement extends Statement {
/**
 * @param {?} expr
 */
constructor(public expr: Expression) { super(); }
/**
 * @param {?} visitor
 * @param {?} context
 * @return {?}
 */
visitStatement(visitor: StatementVisitor, context: any): any {
    return visitor.visitExpressionStmt(this, context);
  }
}

function ExpressionStatement_tsickle_Closure_declarations() {
 /** @type {?} */
ExpressionStatement.prototype.expr;
}



export class ReturnStatement extends Statement {
/**
 * @param {?} value
 */
constructor(public value: Expression) { super(); }
/**
 * @param {?} visitor
 * @param {?} context
 * @return {?}
 */
visitStatement(visitor: StatementVisitor, context: any): any {
    return visitor.visitReturnStmt(this, context);
  }
}

function ReturnStatement_tsickle_Closure_declarations() {
 /** @type {?} */
ReturnStatement.prototype.value;
}


export class AbstractClassPart {
/**
 * @param {?=} type
 * @param {?} modifiers
 */
constructor(public type: Type = null,
public modifiers: StmtModifier[]) {
    if (!modifiers) {
      this.modifiers = [];
    }
  }
/**
 * @param {?} modifier
 * @return {?}
 */
hasModifier(modifier: StmtModifier): boolean { return this.modifiers.indexOf(modifier) !== -1; }
}

function AbstractClassPart_tsickle_Closure_declarations() {
 /** @type {?} */
AbstractClassPart.prototype.type;
 /** @type {?} */
AbstractClassPart.prototype.modifiers;
}


export class ClassField extends AbstractClassPart {
/**
 * @param {?} name
 * @param {?=} type
 * @param {?=} modifiers
 */
constructor(public name: string, type: Type = null, modifiers: StmtModifier[] = null) {
    super(type, modifiers);
  }
}

function ClassField_tsickle_Closure_declarations() {
 /** @type {?} */
ClassField.prototype.name;
}



export class ClassMethod extends AbstractClassPart {
/**
 * @param {?} name
 * @param {?} params
 * @param {?} body
 * @param {?=} type
 * @param {?=} modifiers
 */
constructor(
public name: string,
public params: FnParam[],
public body: Statement[], type: Type = null,
      modifiers: StmtModifier[] = null) {
    super(type, modifiers);
  }
}

function ClassMethod_tsickle_Closure_declarations() {
 /** @type {?} */
ClassMethod.prototype.name;
 /** @type {?} */
ClassMethod.prototype.params;
 /** @type {?} */
ClassMethod.prototype.body;
}



export class ClassGetter extends AbstractClassPart {
/**
 * @param {?} name
 * @param {?} body
 * @param {?=} type
 * @param {?=} modifiers
 */
constructor(
public name: string,
public body: Statement[], type: Type = null,
      modifiers: StmtModifier[] = null) {
    super(type, modifiers);
  }
}

function ClassGetter_tsickle_Closure_declarations() {
 /** @type {?} */
ClassGetter.prototype.name;
 /** @type {?} */
ClassGetter.prototype.body;
}



export class ClassStmt extends Statement {
/**
 * @param {?} name
 * @param {?} parent
 * @param {?} fields
 * @param {?} getters
 * @param {?} constructorMethod
 * @param {?} methods
 * @param {?=} modifiers
 */
constructor(
public name: string,
public parent: Expression,
public fields: ClassField[],
public getters: ClassGetter[],
public constructorMethod: ClassMethod,
public methods: ClassMethod[], modifiers: StmtModifier[] = null) {
    super(modifiers);
  }
/**
 * @param {?} visitor
 * @param {?} context
 * @return {?}
 */
visitStatement(visitor: StatementVisitor, context: any): any {
    return visitor.visitDeclareClassStmt(this, context);
  }
}

function ClassStmt_tsickle_Closure_declarations() {
 /** @type {?} */
ClassStmt.prototype.name;
 /** @type {?} */
ClassStmt.prototype.parent;
 /** @type {?} */
ClassStmt.prototype.fields;
 /** @type {?} */
ClassStmt.prototype.getters;
 /** @type {?} */
ClassStmt.prototype.constructorMethod;
 /** @type {?} */
ClassStmt.prototype.methods;
}



export class IfStmt extends Statement {
/**
 * @param {?} condition
 * @param {?} trueCase
 * @param {?=} falseCase
 */
constructor(
public condition: Expression,
public trueCase: Statement[],
public falseCase: Statement[] = []) {
    super();
  }
/**
 * @param {?} visitor
 * @param {?} context
 * @return {?}
 */
visitStatement(visitor: StatementVisitor, context: any): any {
    return visitor.visitIfStmt(this, context);
  }
}

function IfStmt_tsickle_Closure_declarations() {
 /** @type {?} */
IfStmt.prototype.condition;
 /** @type {?} */
IfStmt.prototype.trueCase;
 /** @type {?} */
IfStmt.prototype.falseCase;
}



export class CommentStmt extends Statement {
/**
 * @param {?} comment
 */
constructor(public comment: string) { super(); }
/**
 * @param {?} visitor
 * @param {?} context
 * @return {?}
 */
visitStatement(visitor: StatementVisitor, context: any): any {
    return visitor.visitCommentStmt(this, context);
  }
}

function CommentStmt_tsickle_Closure_declarations() {
 /** @type {?} */
CommentStmt.prototype.comment;
}



export class TryCatchStmt extends Statement {
/**
 * @param {?} bodyStmts
 * @param {?} catchStmts
 */
constructor(public bodyStmts: Statement[],
public catchStmts: Statement[]) { super(); }
/**
 * @param {?} visitor
 * @param {?} context
 * @return {?}
 */
visitStatement(visitor: StatementVisitor, context: any): any {
    return visitor.visitTryCatchStmt(this, context);
  }
}

function TryCatchStmt_tsickle_Closure_declarations() {
 /** @type {?} */
TryCatchStmt.prototype.bodyStmts;
 /** @type {?} */
TryCatchStmt.prototype.catchStmts;
}



export class ThrowStmt extends Statement {
/**
 * @param {?} error
 */
constructor(public error: Expression) { super(); }
/**
 * @param {?} visitor
 * @param {?} context
 * @return {?}
 */
visitStatement(visitor: StatementVisitor, context: any): any {
    return visitor.visitThrowStmt(this, context);
  }
}

function ThrowStmt_tsickle_Closure_declarations() {
 /** @type {?} */
ThrowStmt.prototype.error;
}


export interface StatementVisitor {
  visitDeclareVarStmt(stmt: DeclareVarStmt, context: any): any;
  visitDeclareFunctionStmt(stmt: DeclareFunctionStmt, context: any): any;
  visitExpressionStmt(stmt: ExpressionStatement, context: any): any;
  visitReturnStmt(stmt: ReturnStatement, context: any): any;
  visitDeclareClassStmt(stmt: ClassStmt, context: any): any;
  visitIfStmt(stmt: IfStmt, context: any): any;
  visitTryCatchStmt(stmt: TryCatchStmt, context: any): any;
  visitThrowStmt(stmt: ThrowStmt, context: any): any;
  visitCommentStmt(stmt: CommentStmt, context: any): any;
}

export class ExpressionTransformer implements StatementVisitor, ExpressionVisitor {
/**
 * @param {?} ast
 * @param {?} context
 * @return {?}
 */
visitReadVarExpr(ast: ReadVarExpr, context: any): any { return ast; }
/**
 * @param {?} expr
 * @param {?} context
 * @return {?}
 */
visitWriteVarExpr(expr: WriteVarExpr, context: any): any {
    return new WriteVarExpr(expr.name, expr.value.visitExpression(this, context));
  }
/**
 * @param {?} expr
 * @param {?} context
 * @return {?}
 */
visitWriteKeyExpr(expr: WriteKeyExpr, context: any): any {
    return new WriteKeyExpr(
        expr.receiver.visitExpression(this, context), expr.index.visitExpression(this, context),
        expr.value.visitExpression(this, context));
  }
/**
 * @param {?} expr
 * @param {?} context
 * @return {?}
 */
visitWritePropExpr(expr: WritePropExpr, context: any): any {
    return new WritePropExpr(
        expr.receiver.visitExpression(this, context), expr.name,
        expr.value.visitExpression(this, context));
  }
/**
 * @param {?} ast
 * @param {?} context
 * @return {?}
 */
visitInvokeMethodExpr(ast: InvokeMethodExpr, context: any): any {
    const /** @type {?} */ method = ast.builtin || ast.name;
    return new InvokeMethodExpr(
        ast.receiver.visitExpression(this, context), method,
        this.visitAllExpressions(ast.args, context), ast.type);
  }
/**
 * @param {?} ast
 * @param {?} context
 * @return {?}
 */
visitInvokeFunctionExpr(ast: InvokeFunctionExpr, context: any): any {
    return new InvokeFunctionExpr(
        ast.fn.visitExpression(this, context), this.visitAllExpressions(ast.args, context),
        ast.type);
  }
/**
 * @param {?} ast
 * @param {?} context
 * @return {?}
 */
visitInstantiateExpr(ast: InstantiateExpr, context: any): any {
    return new InstantiateExpr(
        ast.classExpr.visitExpression(this, context), this.visitAllExpressions(ast.args, context),
        ast.type);
  }
/**
 * @param {?} ast
 * @param {?} context
 * @return {?}
 */
visitLiteralExpr(ast: LiteralExpr, context: any): any { return ast; }
/**
 * @param {?} ast
 * @param {?} context
 * @return {?}
 */
visitExternalExpr(ast: ExternalExpr, context: any): any { return ast; }
/**
 * @param {?} ast
 * @param {?} context
 * @return {?}
 */
visitConditionalExpr(ast: ConditionalExpr, context: any): any {
    return new ConditionalExpr(
        ast.condition.visitExpression(this, context), ast.trueCase.visitExpression(this, context),
        ast.falseCase.visitExpression(this, context));
  }
/**
 * @param {?} ast
 * @param {?} context
 * @return {?}
 */
visitNotExpr(ast: NotExpr, context: any): any {
    return new NotExpr(ast.condition.visitExpression(this, context));
  }
/**
 * @param {?} ast
 * @param {?} context
 * @return {?}
 */
visitCastExpr(ast: CastExpr, context: any): any {
    return new CastExpr(ast.value.visitExpression(this, context), context);
  }
/**
 * @param {?} ast
 * @param {?} context
 * @return {?}
 */
visitFunctionExpr(ast: FunctionExpr, context: any): any {
    // Don't descend into nested functions
    return ast;
  }
/**
 * @param {?} ast
 * @param {?} context
 * @return {?}
 */
visitBinaryOperatorExpr(ast: BinaryOperatorExpr, context: any): any {
    return new BinaryOperatorExpr(
        ast.operator, ast.lhs.visitExpression(this, context),
        ast.rhs.visitExpression(this, context), ast.type);
  }
/**
 * @param {?} ast
 * @param {?} context
 * @return {?}
 */
visitReadPropExpr(ast: ReadPropExpr, context: any): any {
    return new ReadPropExpr(ast.receiver.visitExpression(this, context), ast.name, ast.type);
  }
/**
 * @param {?} ast
 * @param {?} context
 * @return {?}
 */
visitReadKeyExpr(ast: ReadKeyExpr, context: any): any {
    return new ReadKeyExpr(
        ast.receiver.visitExpression(this, context), ast.index.visitExpression(this, context),
        ast.type);
  }
/**
 * @param {?} ast
 * @param {?} context
 * @return {?}
 */
visitLiteralArrayExpr(ast: LiteralArrayExpr, context: any): any {
    return new LiteralArrayExpr(this.visitAllExpressions(ast.entries, context));
  }
/**
 * @param {?} ast
 * @param {?} context
 * @return {?}
 */
visitLiteralMapExpr(ast: LiteralMapExpr, context: any): any {
    const /** @type {?} */ entries = ast.entries.map(
        (entry): LiteralMapEntry => new LiteralMapEntry(
            entry.key, entry.value.visitExpression(this, context), entry.quoted));
    return new LiteralMapExpr(entries);
  }
/**
 * @param {?} exprs
 * @param {?} context
 * @return {?}
 */
visitAllExpressions(exprs: Expression[], context: any): Expression[] {
    return exprs.map(expr => expr.visitExpression(this, context));
  }
/**
 * @param {?} stmt
 * @param {?} context
 * @return {?}
 */
visitDeclareVarStmt(stmt: DeclareVarStmt, context: any): any {
    return new DeclareVarStmt(
        stmt.name, stmt.value.visitExpression(this, context), stmt.type, stmt.modifiers);
  }
/**
 * @param {?} stmt
 * @param {?} context
 * @return {?}
 */
visitDeclareFunctionStmt(stmt: DeclareFunctionStmt, context: any): any {
    // Don't descend into nested functions
    return stmt;
  }
/**
 * @param {?} stmt
 * @param {?} context
 * @return {?}
 */
visitExpressionStmt(stmt: ExpressionStatement, context: any): any {
    return new ExpressionStatement(stmt.expr.visitExpression(this, context));
  }
/**
 * @param {?} stmt
 * @param {?} context
 * @return {?}
 */
visitReturnStmt(stmt: ReturnStatement, context: any): any {
    return new ReturnStatement(stmt.value.visitExpression(this, context));
  }
/**
 * @param {?} stmt
 * @param {?} context
 * @return {?}
 */
visitDeclareClassStmt(stmt: ClassStmt, context: any): any {
    // Don't descend into nested functions
    return stmt;
  }
/**
 * @param {?} stmt
 * @param {?} context
 * @return {?}
 */
visitIfStmt(stmt: IfStmt, context: any): any {
    return new IfStmt(
        stmt.condition.visitExpression(this, context),
        this.visitAllStatements(stmt.trueCase, context),
        this.visitAllStatements(stmt.falseCase, context));
  }
/**
 * @param {?} stmt
 * @param {?} context
 * @return {?}
 */
visitTryCatchStmt(stmt: TryCatchStmt, context: any): any {
    return new TryCatchStmt(
        this.visitAllStatements(stmt.bodyStmts, context),
        this.visitAllStatements(stmt.catchStmts, context));
  }
/**
 * @param {?} stmt
 * @param {?} context
 * @return {?}
 */
visitThrowStmt(stmt: ThrowStmt, context: any): any {
    return new ThrowStmt(stmt.error.visitExpression(this, context));
  }
/**
 * @param {?} stmt
 * @param {?} context
 * @return {?}
 */
visitCommentStmt(stmt: CommentStmt, context: any): any { return stmt; }
/**
 * @param {?} stmts
 * @param {?} context
 * @return {?}
 */
visitAllStatements(stmts: Statement[], context: any): Statement[] {
    return stmts.map(stmt => stmt.visitStatement(this, context));
  }
}


export class RecursiveExpressionVisitor implements StatementVisitor, ExpressionVisitor {
/**
 * @param {?} ast
 * @param {?} context
 * @return {?}
 */
visitReadVarExpr(ast: ReadVarExpr, context: any): any { return ast; }
/**
 * @param {?} expr
 * @param {?} context
 * @return {?}
 */
visitWriteVarExpr(expr: WriteVarExpr, context: any): any {
    expr.value.visitExpression(this, context);
    return expr;
  }
/**
 * @param {?} expr
 * @param {?} context
 * @return {?}
 */
visitWriteKeyExpr(expr: WriteKeyExpr, context: any): any {
    expr.receiver.visitExpression(this, context);
    expr.index.visitExpression(this, context);
    expr.value.visitExpression(this, context);
    return expr;
  }
/**
 * @param {?} expr
 * @param {?} context
 * @return {?}
 */
visitWritePropExpr(expr: WritePropExpr, context: any): any {
    expr.receiver.visitExpression(this, context);
    expr.value.visitExpression(this, context);
    return expr;
  }
/**
 * @param {?} ast
 * @param {?} context
 * @return {?}
 */
visitInvokeMethodExpr(ast: InvokeMethodExpr, context: any): any {
    ast.receiver.visitExpression(this, context);
    this.visitAllExpressions(ast.args, context);
    return ast;
  }
/**
 * @param {?} ast
 * @param {?} context
 * @return {?}
 */
visitInvokeFunctionExpr(ast: InvokeFunctionExpr, context: any): any {
    ast.fn.visitExpression(this, context);
    this.visitAllExpressions(ast.args, context);
    return ast;
  }
/**
 * @param {?} ast
 * @param {?} context
 * @return {?}
 */
visitInstantiateExpr(ast: InstantiateExpr, context: any): any {
    ast.classExpr.visitExpression(this, context);
    this.visitAllExpressions(ast.args, context);
    return ast;
  }
/**
 * @param {?} ast
 * @param {?} context
 * @return {?}
 */
visitLiteralExpr(ast: LiteralExpr, context: any): any { return ast; }
/**
 * @param {?} ast
 * @param {?} context
 * @return {?}
 */
visitExternalExpr(ast: ExternalExpr, context: any): any { return ast; }
/**
 * @param {?} ast
 * @param {?} context
 * @return {?}
 */
visitConditionalExpr(ast: ConditionalExpr, context: any): any {
    ast.condition.visitExpression(this, context);
    ast.trueCase.visitExpression(this, context);
    ast.falseCase.visitExpression(this, context);
    return ast;
  }
/**
 * @param {?} ast
 * @param {?} context
 * @return {?}
 */
visitNotExpr(ast: NotExpr, context: any): any {
    ast.condition.visitExpression(this, context);
    return ast;
  }
/**
 * @param {?} ast
 * @param {?} context
 * @return {?}
 */
visitCastExpr(ast: CastExpr, context: any): any {
    ast.value.visitExpression(this, context);
    return ast;
  }
/**
 * @param {?} ast
 * @param {?} context
 * @return {?}
 */
visitFunctionExpr(ast: FunctionExpr, context: any): any { return ast; }
/**
 * @param {?} ast
 * @param {?} context
 * @return {?}
 */
visitBinaryOperatorExpr(ast: BinaryOperatorExpr, context: any): any {
    ast.lhs.visitExpression(this, context);
    ast.rhs.visitExpression(this, context);
    return ast;
  }
/**
 * @param {?} ast
 * @param {?} context
 * @return {?}
 */
visitReadPropExpr(ast: ReadPropExpr, context: any): any {
    ast.receiver.visitExpression(this, context);
    return ast;
  }
/**
 * @param {?} ast
 * @param {?} context
 * @return {?}
 */
visitReadKeyExpr(ast: ReadKeyExpr, context: any): any {
    ast.receiver.visitExpression(this, context);
    ast.index.visitExpression(this, context);
    return ast;
  }
/**
 * @param {?} ast
 * @param {?} context
 * @return {?}
 */
visitLiteralArrayExpr(ast: LiteralArrayExpr, context: any): any {
    this.visitAllExpressions(ast.entries, context);
    return ast;
  }
/**
 * @param {?} ast
 * @param {?} context
 * @return {?}
 */
visitLiteralMapExpr(ast: LiteralMapExpr, context: any): any {
    ast.entries.forEach((entry) => entry.value.visitExpression(this, context));
    return ast;
  }
/**
 * @param {?} exprs
 * @param {?} context
 * @return {?}
 */
visitAllExpressions(exprs: Expression[], context: any): void {
    exprs.forEach(expr => expr.visitExpression(this, context));
  }
/**
 * @param {?} stmt
 * @param {?} context
 * @return {?}
 */
visitDeclareVarStmt(stmt: DeclareVarStmt, context: any): any {
    stmt.value.visitExpression(this, context);
    return stmt;
  }
/**
 * @param {?} stmt
 * @param {?} context
 * @return {?}
 */
visitDeclareFunctionStmt(stmt: DeclareFunctionStmt, context: any): any {
    // Don't descend into nested functions
    return stmt;
  }
/**
 * @param {?} stmt
 * @param {?} context
 * @return {?}
 */
visitExpressionStmt(stmt: ExpressionStatement, context: any): any {
    stmt.expr.visitExpression(this, context);
    return stmt;
  }
/**
 * @param {?} stmt
 * @param {?} context
 * @return {?}
 */
visitReturnStmt(stmt: ReturnStatement, context: any): any {
    stmt.value.visitExpression(this, context);
    return stmt;
  }
/**
 * @param {?} stmt
 * @param {?} context
 * @return {?}
 */
visitDeclareClassStmt(stmt: ClassStmt, context: any): any {
    // Don't descend into nested functions
    return stmt;
  }
/**
 * @param {?} stmt
 * @param {?} context
 * @return {?}
 */
visitIfStmt(stmt: IfStmt, context: any): any {
    stmt.condition.visitExpression(this, context);
    this.visitAllStatements(stmt.trueCase, context);
    this.visitAllStatements(stmt.falseCase, context);
    return stmt;
  }
/**
 * @param {?} stmt
 * @param {?} context
 * @return {?}
 */
visitTryCatchStmt(stmt: TryCatchStmt, context: any): any {
    this.visitAllStatements(stmt.bodyStmts, context);
    this.visitAllStatements(stmt.catchStmts, context);
    return stmt;
  }
/**
 * @param {?} stmt
 * @param {?} context
 * @return {?}
 */
visitThrowStmt(stmt: ThrowStmt, context: any): any {
    stmt.error.visitExpression(this, context);
    return stmt;
  }
/**
 * @param {?} stmt
 * @param {?} context
 * @return {?}
 */
visitCommentStmt(stmt: CommentStmt, context: any): any { return stmt; }
/**
 * @param {?} stmts
 * @param {?} context
 * @return {?}
 */
visitAllStatements(stmts: Statement[], context: any): void {
    stmts.forEach(stmt => stmt.visitStatement(this, context));
  }
}
/**
 * @param {?} varName
 * @param {?} newValue
 * @param {?} expression
 * @return {?}
 */
export function replaceVarInExpression(
    varName: string, newValue: Expression, expression: Expression): Expression {
  const /** @type {?} */ transformer = new _ReplaceVariableTransformer(varName, newValue);
  return expression.visitExpression(transformer, null);
}

class _ReplaceVariableTransformer extends ExpressionTransformer {
/**
 * @param {?} _varName
 * @param {?} _newValue
 */
constructor(private _varName: string,
private _newValue: Expression) { super(); }
/**
 * @param {?} ast
 * @param {?} context
 * @return {?}
 */
visitReadVarExpr(ast: ReadVarExpr, context: any): any {
    return ast.name == this._varName ? this._newValue : ast;
  }
}

function _ReplaceVariableTransformer_tsickle_Closure_declarations() {
 /** @type {?} */
_ReplaceVariableTransformer.prototype._varName;
 /** @type {?} */
_ReplaceVariableTransformer.prototype._newValue;
}

/**
 * @param {?} stmts
 * @return {?}
 */
export function findReadVarNames(stmts: Statement[]): Set<string> {
  const /** @type {?} */ finder = new _VariableFinder();
  finder.visitAllStatements(stmts, null);
  return finder.varNames;
}

class _VariableFinder extends RecursiveExpressionVisitor {
  varNames = new Set<string>();
/**
 * @param {?} ast
 * @param {?} context
 * @return {?}
 */
visitReadVarExpr(ast: ReadVarExpr, context: any): any {
    this.varNames.add(ast.name);
    return null;
  }
}

function _VariableFinder_tsickle_Closure_declarations() {
 /** @type {?} */
_VariableFinder.prototype.varNames;
}

/**
 * @param {?} name
 * @param {?=} type
 * @return {?}
 */
export function variable(name: string, type: Type = null): ReadVarExpr {
  return new ReadVarExpr(name, type);
}
/**
 * @param {?} id
 * @param {?=} typeParams
 * @return {?}
 */
export function importExpr(id: CompileIdentifierMetadata, typeParams: Type[] = null): ExternalExpr {
  return new ExternalExpr(id, null, typeParams);
}
/**
 * @param {?} id
 * @param {?=} typeParams
 * @param {?=} typeModifiers
 * @return {?}
 */
export function importType(
    id: CompileIdentifierMetadata, typeParams: Type[] = null,
    typeModifiers: TypeModifier[] = null): ExpressionType {
  return isPresent(id) ? expressionType(importExpr(id), typeParams, typeModifiers) : null;
}
/**
 * @param {?} expr
 * @param {?=} typeParams
 * @param {?=} typeModifiers
 * @return {?}
 */
export function expressionType(
    expr: Expression, typeParams: Type[] = null,
    typeModifiers: TypeModifier[] = null): ExpressionType {
  return isPresent(expr) ? new ExpressionType(expr, typeParams, typeModifiers) : null;
}
/**
 * @param {?} values
 * @param {?=} type
 * @return {?}
 */
export function literalArr(values: Expression[], type: Type = null): LiteralArrayExpr {
  return new LiteralArrayExpr(values, type);
}
/**
 * @param {?} values
 * @param {?=} type
 * @return {?}
 */
export function literalMap(values: [string, Expression][], type: MapType = null): LiteralMapExpr {
  return new LiteralMapExpr(values.map(entry => new LiteralMapEntry(entry[0], entry[1])), type);
}
/**
 * @param {?} expr
 * @return {?}
 */
export function not(expr: Expression): NotExpr {
  return new NotExpr(expr);
}
/**
 * @param {?} params
 * @param {?} body
 * @param {?=} type
 * @return {?}
 */
export function fn(params: FnParam[], body: Statement[], type: Type = null): FunctionExpr {
  return new FunctionExpr(params, body, type);
}
/**
 * @param {?} value
 * @param {?=} type
 * @return {?}
 */
export function literal(value: any, type: Type = null): LiteralExpr {
  return new LiteralExpr(value, type);
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
